import React from "react";
import { Link } from "react-router-dom";
import useSEO from "../lib/useSEO";

export default function NotFound() {
    useSEO({ title: "Page not found", description: "The page you requested could not be found.", path: "/404" });
    return (
        <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center" data-testid="page-404">
            <div className="font-mono-cap text-xs text-[#c5a059] mb-3">404 · Page not found</div>
            <h1 className="font-serif-display text-5xl md:text-7xl text-slate-900 leading-tight">
                The page you sought is <em className="not-italic text-[#c5a059]">no longer on file.</em>
            </h1>
            <p className="mt-8 text-[17px] text-slate-800 leading-relaxed max-w-xl mx-auto">
                Either the link you followed has been removed or you mistyped the address. Return to the
                chambers or browse our publications and insights.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
                <Link to="/" className="inline-flex items-center gap-2 bg-[#0F172A] text-[#faf9f6] px-6 py-3 rounded-sm hover:bg-[#c5a059] hover:text-[#0F172A] transition-colors" data-testid="nf-home">Back to home</Link>
                <Link to="/contact" className="inline-flex items-center gap-2 border border-slate-900/20 px-6 py-3 rounded-sm hover:border-[#c5a059] transition-colors" data-testid="nf-contact">Contact us</Link>
            </div>
        </section>
    );
}
